











































































import { Vue, Component, Watch } from "vue-property-decorator"
import RecipeHeader from "@/components/BaseComponents/RecipeHeader.vue"
import IngredientsList from "@/components/BaseComponents/IngredientsList.vue"
import PreparationsOverview from "@/components/BaseComponents/PreparationsOverview.vue"
import RecipeProcedure from "@/components/RecipeProcedure.vue"
import RecipeImages from "@/components/RecipeImages.vue"
import RelatedRecipeList from "@/components/BaseComponents/RelatedRecipeList.vue"
import ImageModal from "@/components/BaseComponents/ImageModal.vue"
import TextBox from "@/components/BaseComponents/TextBox.vue"

import LoadImage from "@/plugin/mixin/loadImage"

const AppProps = Vue.extend({
	props: {
	}
})

@Component({
	components: {
		PreparationsOverview,
		RecipeHeader,
		IngredientsList,
		RecipeProcedure,
		RecipeImages,
		RelatedRecipeList,
		ImageModal,
		TextBox
	},
	mixins: [
		LoadImage
	]
})
export default class RecipeCard extends AppProps {
	recipe!: RecipeObject;
	numberOfPortions = 1;

	@Watch("$route.params.name")
	onProperyChanged(value: string) {
		this.$store.dispatch("setRecipe", value)
	}

	created() {
		this.$root.$on("update-portions", this.setNumberOfPortions)
		this.$store.dispatch("setRecipe", this.$route.params.name)
	}

	setNumberOfPortions(event: number) {
		this.numberOfPortions = event
	}
}
